import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {PortalUserProfileView} from '../../../models/generated-models';

@Injectable({providedIn: 'root'})
export class ProfileRest {
  http = inject(HttpClient);

  getUserProfile() {
    return this.http.get<PortalUserProfileView>(`${environment.portalBaseUrl}/api/v1/users/profile`);
  }
}
